module.exports = __webpack_public_path__ + "static/financial-services-sectors-a5b580e4181be68c8c9ba54ea742bc03.jpg";